import { Modal } from '@mui/material';
import AuthForm from 'app/auth/components/auth-form';
import { RoutesList } from 'enums/routes-list.enum';
import { ZIndexes } from 'enums/z-indexes';

interface SignInModalProps {
  username: string;
  open: boolean;
  onClose: () => void;
}

const SignInModal = ({ open, onClose, username }: SignInModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: ZIndexes.External_Modal_First,
      }}
    >
      <>
        <AuthForm
          navigateRoute={RoutesList.Creators_Profile.replace(
            ':username',
            username
          )}
          isPublic
        />
      </>
    </Modal>
  );
};

export default SignInModal;
